import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { OccurenceComments } from '@app/occurences/add-occurence-modal/occurence-list-comments/occurence-comments.interface';
import { ConfirmDialogComponent } from '@shared/confirm-dialog/confirm-dialog.component';

import { MatBottomSheet } from '@angular/material';
import { OccurencesService } from '@app/occurences/occurences.service';
import { SnackbarService } from '@app/shared/services/snackbar.service';
import { AuthService } from '@app/core/auth/auth.service';
import { AuthUser } from '@app/core/auth/auth-frame/auth-user.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-occurrence-read-manager',
  templateUrl: './occurrence-read-manager.component.html',
  styleUrls: ['./occurrence-read-manager.component.css']
})

export class OccurrenceReadManagerComponent implements OnInit {

  @Input() comment: OccurenceComments;
  authSubject: Observable<AuthUser>;
  public currentGestor: String;

  constructor(
    private occurenceService: OccurencesService,
    private _snackbarService: SnackbarService,
    private bottomSheet: MatBottomSheet,
    private authService: AuthService
  ) {
    this.currentGestor = this.occurenceService.getCurrentGestorLogged();
  }

  ngOnInit() {

  }

  readComment(comment: OccurenceComments): void {
    this.bottomSheet.open(ConfirmDialogComponent, {
      data: {
        message: 'Essa ação desabilita a notificação na grid de demandas. Essa ação não pode ser desfeita. Deseja continuar?',
        confirmMessage: 'Sim',
        cancelMessage: 'Não'
      }
    }).afterDismissed().subscribe(data => {
      if (data && data.message === 'Confirm') {
        const commentDto: OccurenceComments = {
          id: comment.id,
          // readUserName: this.authService.currentUserValue.name,
          // userName: comment.userName,
          occurrenceId: comment.occurrenceId,
          readDateTime: new Date()
        };

        this.occurenceService.manageReadComment(commentDto).subscribe(
          (resp) => {
            this.afterReadSuccess(comment, resp.readUserName, resp.readDateTime);
          }, err => {
            this.afterReadFail();
          }
        );
      }
    });
  }

  afterReadSuccess(comment: OccurenceComments, readUserName: String, readDateTime: Date): void {
    comment.readUserName = readUserName;
    comment.readDateTime = readDateTime;
    this._snackbarService.showSnackbar('O comentário foi lido com sucesso.', 'OK');
  }

  afterReadFail(): void {
    this._snackbarService.showSnackbar("Falha ao atualizar o comentário.", "OK");
  }

  handlePermissionComment(): boolean {
    return true;
  }

}
